import React, { lazy } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { LanguageProvider } from './contexts/LanguageContext'
import { SchedulerAuthProvider } from './contexts/SchedulerAuthContext'
import { ToastProvider } from './contexts/ToastContext'
import { HubThemeProvider, HubThemeDocumentSync } from './contexts/HubThemeContext'
import ErrorBoundary from './components/ErrorBoundary'
import ScrollToTop from './components/ScrollToTop'
import LanguageRouteSync from './components/LanguageRouteSync'
import HubFavicon from './components/hub/HubFavicon'
import HubToaster from './components/hub/HubToaster'
import { RouteSuspense } from './routes/RouteSuspense'

const HubRoutes = lazy(() => import('./routes/hub-routes.jsx'))
const SchedulerRoutes = lazy(() => import('./routes/scheduler-routes.jsx'))
const MarketingRoutes = lazy(() => import('./routes/marketing-routes.jsx'))

function App() {
  return (
    <ErrorBoundary>
      <LanguageProvider>
        <SchedulerAuthProvider>
          <ToastProvider>
            <HubThemeProvider>
              <Router>
                <HubFavicon />
                <HubThemeDocumentSync />
                <ScrollToTop />
                <LanguageRouteSync />
                <HubToaster />
                <Routes>
                  <Route
                    path="/hub/*"
                    element={
                      <RouteSuspense>
                        <HubRoutes />
                      </RouteSuspense>
                    }
                  />
                  <Route
                    path="/scheduler/*"
                    element={
                      <RouteSuspense>
                        <SchedulerRoutes />
                      </RouteSuspense>
                    }
                  />
                  <Route
                    path="*"
                    element={
                      <RouteSuspense>
                        <MarketingRoutes />
                      </RouteSuspense>
                    }
                  />
                </Routes>
              </Router>
            </HubThemeProvider>
          </ToastProvider>
        </SchedulerAuthProvider>
      </LanguageProvider>
    </ErrorBoundary>
  )
}

export default App
